import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import {
  CompanyCalendarGigDto,
  CompanyCalendarTimereport,
} from "model/Calendar";
import { TimeReportResolution } from "model/TimeReport";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { shiftWithAbsence } from "web-apps/company/utils/utils";
import { TimeReportModalContainer } from "../timeReportModalContainer.component";
import { ShiftCell } from "../weeklyCalendar.styled";

type Props = {
  name: string;
  compactView: boolean;
  timeReport: CompanyCalendarTimereport | undefined;
  keyId: number;
  dashboard: boolean | undefined;
  gigDataId: number;
  gigData: CompanyCalendarGigDto;
};

export const FilledCalendarGig: React.FC<Props> = ({
  name,
  compactView,
  timeReport,
  keyId,
  dashboard,
  gigDataId,
  gigData,
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const tooltipContent = compactView
    ? `${moment(timeReport?.startTime).format("HH:mm") ?? ""} - ${
        moment(timeReport?.endTime).format("HH:mm") ?? ""
      }`
    : name;

  return (
    <>
      <ShiftCell
        key={keyId}
        backgroundColor={
          timeReport &&
          shiftWithAbsence(timeReport) &&
          new Date(timeReport.startTime) > new Date()
            ? Color.LighterDestructive
            : timeReport &&
              (shiftWithAbsence(timeReport) ||
                timeReport.resolution == TimeReportResolution.WITHDRAWN)
            ? Color.LightWarning
            : Color.Positive
        }
        data-tooltip-id={"worker-name"}
        data-tooltip-content={tooltipContent}
        onClick={() => {
          if (timeReport) {
            setModalOpen(true);
          }
        }}
      >
        {!compactView ? (
          <Text color={Color.White}>
            {timeReport
              ? `${moment(timeReport.startTime).format("HH:mm")} - ${moment(
                  timeReport.endTime
                ).format("HH:mm")}`
              : ""}
          </Text>
        ) : (
          <Text fontSize={FontSize.Small} color={Color.White}>{`${
            name.length > 6 && dashboard
              ? `${name.slice(0, 6)}...`
              : name
              ? `${name}`
              : dashboard && !name
              ? t(t("CalendarCompany.NotFilled")).slice(0, 7) + "..."
              : t(t("CalendarCompany.NotFilled"))
          }`}</Text>
        )}
        {!compactView ? (
          <Text color={Color.White}>{tooltipContent}</Text>
        ) : (
          <Tooltip
            id={"worker-name"}
            place="top"
            style={{
              backgroundColor: Color.White,
              color: Color.MidnightBlue,
              fontFamily: FontFamily.MontserratRegular,
              boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.1)",
            }}
          />
        )}
      </ShiftCell>
      {timeReport && (
        <TimeReportModalContainer
          timeReportId={timeReport.id}
          gigId={gigDataId}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          calenderView
          gigData={gigData}
        />
      )}
    </>
  );
};
